import { i18n } from "../../private/languageSelector";

// Mirrors getPosEnvironment / getEnvironmentLabel in the backend's helpers/zatca-environment.js.
// pos.zatca.environment is the source of truth; POS onboarded before it existed only carry the
// deprecated useTestCSR flag (true = sandbox, otherwise simulation - never production).
export const ZATCA_ENVIRONMENTS = ["sandbox", "simulation", "production"];

export const getPosEnvironment = (pos) => {
  const zatca = pos?.zatca || {};
  if (ZATCA_ENVIRONMENTS.includes(zatca.environment)) return zatca.environment;
  return zatca.useTestCSR === true ? "sandbox" : "simulation";
};

export const getEnvironmentLabel = (environment) => {
  switch (environment) {
    case "sandbox":
      return "Sandbox";
    case "simulation":
      return i18n("Integration.Simulation");
    case "production":
      return i18n("Integration.Production");
    default:
      return "";
  }
};
